"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setObjectKeysToTrue = setObjectKeysToTrue;
exports.isObjectOrNothing = exports.getUnusedKeys = exports.getId = exports.getObjectKeysFromString = void 0;

var _get = _interopRequireDefault(require("lodash/get"));

var _keys = _interopRequireDefault(require("lodash/keys"));

var _difference = _interopRequireDefault(require("lodash/difference"));

var _isObject = _interopRequireDefault(require("lodash/isObject"));

var _isUndefined = _interopRequireDefault(require("lodash/isUndefined"));

var _isNull = _interopRequireDefault(require("lodash/isNull"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @namespace skybase-core.utils.object
 */

/**
 * @description
 * this function will parse a string according specified divider and create
 * an object with keys from parsed string, value for these new keys will be <code>null</code>
 * @function
 *
 * @name skybase-core.utils.object#getObjectKeysFromString
 * @param  {String} [text='']
 * @param  {String} [divider=' ']
 * @return {Object}
 */
var getObjectKeysFromString = function getObjectKeysFromString() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var divider = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ' ';
  return text.split(divider).reduce(function (classObj, className) {
    classObj[className] = null;
    return classObj;
  }, {});
};
/**
 * @description
 * create new object with same keys as specified object, but values are set to <code>true</code>
 * @function
 *
 * @name skybase-core.utils.object#setObjectKeysToTrue
 * @param {Object} [obj={}]
 * @return {Object}
 */


exports.getObjectKeysFromString = getObjectKeysFromString;

function setObjectKeysToTrue() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.getOwnPropertyNames(obj).reduce(function (newObj, propertyName) {
    newObj[propertyName] = true;
    return newObj;
  }, {});
}
/**
 * @description
 * extract the Id from an object
 * @function
 *
 * @name skybase-core.utils.object#getId
 * @param {Object} obj object with the key <code>id</code>
 * @return {String}
 */


var getId = function getId(item) {
  return (0, _get.default)(item, 'id');
};
/**
 * @description
 * filters list of keys, which are not present in object specified as second argument
 * @function
 *
 * @name skybase-core.utils.object#getUnusedKeys
 * @param {Array<String>|immutablejs.List<String>} keysList - the list of keys
 * @param {Object} object - the list of keys to compare with
 * @return {Array<String>|immutablejs.List<String>}
 */


exports.getId = getId;

var getUnusedKeys = function getUnusedKeys(keysList, object) {
  return (0, _difference.default)(keysList, (0, _keys.default)(object));
};
/**
 * @description
 * checks if object is javascript object or is undefined or is null
 * @function
 *
 * @name skybase-core.utils.object#isObjectOrNothing
 * @param {Object} object - object to test
 * @return {Boolean}
 */


exports.getUnusedKeys = getUnusedKeys;

var isObjectOrNothing = function isObjectOrNothing(obj) {
  return (0, _isObject.default)(obj) || (0, _isUndefined.default)(obj) || (0, _isNull.default)(obj);
};

exports.isObjectOrNothing = isObjectOrNothing;
//# sourceMappingURL=object.js.map